/** Matches legacy mobile `DEFAULT_CONTACT_AREA_CATEGORY`. */
export const DEFAULT_CONTACT_AREA = "No Contact Area";

/** When an area has at most this many contacts, show cards inline instead of a list hub. */
export const CONTACT_INLINE_CARD_THRESHOLD = 8;

export function contactAreaLabel(raw: Record<string, unknown>): string {
  const area = raw.contactArea ?? raw.ContactArea;
  if (typeof area === "string" && area.trim()) return area.trim();
  return DEFAULT_CONTACT_AREA;
}

export function compareContactDisplayNames(a: string, b: string): number {
  return a.localeCompare(b, undefined, { sensitivity: "base", numeric: true });
}

export function compareContactsForDisplay(
  a: { displayName: string; lastName?: string },
  b: { displayName: string; lastName?: string },
): number {
  const aLast = a.lastName?.trim();
  const bLast = b.lastName?.trim();
  if (aLast && bLast) {
    const byLast = compareContactDisplayNames(aLast, bLast);
    if (byLast !== 0) return byLast;
  }
  return compareContactDisplayNames(a.displayName, b.displayName);
}

export function compareAssetDisplayNames(a: string, b: string): number {
  return a.localeCompare(b, undefined, { sensitivity: "base", numeric: true });
}
